import {useCallback} from 'react';

import * as FilterActions from '../../../state/views/filter/actions';
import {type Ref as FilterRef} from '../../../state/views/filter/types';
import {useViewAction} from '../../../state/views/hooks';
import {type FilterV2Root} from '../../../util/filterV2';
import {
  type AgentActionArgs,
  useRegisterAgentActionHandler,
} from '../agentActionHandlers';
import {SET_RUN_FILTER_TOOL_NAME} from '../tools/RunFilterToolUI';
import {buildFilterRootFromArgs} from './agentActionFilter';

type SetFilters = (filters: FilterV2Root) => void;

export const WBAgentSetFilterActionSlice = ({
  filtersRef,
}: {
  filtersRef: FilterRef;
}): null => {
  const setFilters = useViewAction(filtersRef, FilterActions.set) as SetFilters;
  const execute = useCallback(
    (args: AgentActionArgs) => setFilters(buildFilterRootFromArgs(args)),
    [setFilters]
  );
  useRegisterAgentActionHandler(SET_RUN_FILTER_TOOL_NAME, execute);
  return null;
};
